export default __webpack_public_path__ + "static/media/coreCard2.90a9c5a2.svg";